import { useEffect } from 'react';
import { useCXRootStore } from '../stores/cx-root-store.provider';
import { getCXEnvironment } from '~/utils/cx-utils/cx-environment.utils';
import { waitForWindowProperty } from '~/utils/third-party-loader.utils';

export default function useLoadClientPortal(
    {
        isFromAngular = false
    }: {
        isFromAngular?: boolean;
    } = { isFromAngular: false }
) {
    const { configCtrl, clientPortalConfigStore } = useCXRootStore();

    if (!clientPortalConfigStore.env) {
        clientPortalConfigStore.setClientPortalEnv(getCXEnvironment());
    }

    useEffect(() => {
        if (isFromAngular) {
            // Wait for window.clientPortalConfiguration to be loaded on the window
            waitForWindowProperty('clientPortalConfiguration').then(() => {
                clientPortalConfigStore.setClientPortalConfiguration(
                    window.clientPortalConfiguration as any
                );
            });
            return;
        }

        if (!clientPortalConfigStore.configuration) {
            configCtrl.loadClientPortalConfiguration();
        }
    }, [configCtrl, clientPortalConfigStore, isFromAngular]);
}
